import React from 'react'

const QuestionIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="#808F94"
        d="M9 17.99a9.054 9.054 0 0 0 8.99-9 9.06 9.06 0 0 0-9-8.99A9.052 9.052 0 0 0 0 8.99a9.062 9.062 0 0 0 9 9Zm-.176-7.125c-.51 0-.789-.25-.789-.742v-.111a2.125 2.125 0 0 1 1.15-1.818c.808-.558 1.188-.867 1.188-1.476a1.17 1.17 0 0 0-1.327-1.123 1.474 1.474 0 0 0-1.313.779c-.288.343-.39.612-.918.612a.653.653 0 0 1-.682-.659c.002-.157.027-.314.074-.464.25-.863 1.317-1.586 2.9-1.586s2.959.835 2.959 2.366c0 1.095-.622 1.614-1.521 2.217-.612.427-.937.742-.946 1.243v.1a.7.7 0 0 1-.775.662Zm.037 2.672a.992.992 0 0 1-1.011-.965.986.986 0 0 1 1.011-.965.982.982 0 0 1 1.011.965.986.986 0 0 1-1.011.964v.001Z"
      />
    </svg>
  )
}

export default QuestionIcon
